module.exports = __webpack_public_path__ + "static/media/2_en.0bdb8a87.png";